import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_9rhufegspe_hero_mothers_day_refined_1: FaireThemeEntity =
  {
    token: "board_demo_r_9rhufegspe_hero_mothers_day_refined_1",
    type: "theme",
    retailerToken: "r_9rhufegspe",
    name: "Mother's Day picks",
    description:
      "Twenty-eight picks curated for your Jersey City boho-home-and-gift boutique. Expect women-owned keepsake jewelry with a message, small-batch self-care kits, and pressed-floral statement pieces that sit alongside your Mother's Day table and stay relevant on your shelves after the holiday.",
    bgColor: "#F5D4E8",
    productTokens: [
      "p_rxvve8b7tb",
      "p_tqm72ytyyn",
      "p_qkbxk7hse3",
      "p_8335qn2cjd",
      "p_cuhq8quqvw",
      "p_2rk3q2mr6g",
      "p_m7nkuj9gg6",
      "p_wpxw5y4mk6",
      "p_2wdyzrav1i",
      "p_c0hafp9vmv",
      "p_tw3fvzvq4d",
      "p_mswsmgkx5x",
      "p_r762uv929k",
      "p_69cxscyjmr",
      "p_4zsa77jmqv",
      "p_3casjkgfsj",
      "p_yyyr26ftt5",
      "p_php6rwgsa6",
      "p_ugwv3cgvqe",
      "p_40l7femjgj",
    ],
    coverImageUrl:
      "https://cdn.faire.com/fastly/efd4664aecfb89006208301a8bc1e7930e536727d9f96ef4dc720482773e1815.jpeg",
    thumbnailImageUrls: [
      "https://cdn.faire.com/fastly/efd4664aecfb89006208301a8bc1e7930e536727d9f96ef4dc720482773e1815.jpeg",
      "https://cdn.faire.com/fastly/3c501d7ac03773c1217cce8b7bf2cb7ec7517a7f9704bf55932a4f419286dc5d.jpeg",
      "https://cdn.faire.com/fastly/aba69874d8a7d8ddad1b9e97be84ddcb6125c4f264a47c65989ce3059244878c.jpeg",
      "https://cdn.faire.com/fastly/3fc7de40053e8c5173787e8923b15b6e19fe5d03c01552027349b239b8a65a26.jpeg",
      "https://cdn.faire.com/fastly/45d76dca0f27bd358ed71641ac3fca958c494645729585be4bab73dd78b23063.jpeg",
      "https://cdn.faire.com/fastly/17f8f72706753cd3f4c41c5aeea900f1bc34346b56f53413d48b571c1262067f.jpeg",
    ],
    itemCount: 28,
    source: "curated_md_hero_refined_1",
    teaser: "mothers-day-picks",
    meta: {
      source: "mock",
      importedAt: "2026-04-19T23:00:00.000Z",
      importedBy: "board-demo-canonicalize",
    },
  };
